import { useQuery } from "react-query";
import { ParamsGetAssetRevenue, GetAssetRevenueResponse } from "../../constants/types";
import axios from "../axios";
import queryString from "query-string";

const handleRequest = async (params: ParamsGetAssetRevenue) => {
    if (!params.ukmId || params.ukmId === "undefined") return null;
    const apiGetItem = queryString.stringifyUrl({
        url: "api/items/summary-keuangan",
        query: {
            ukmId: params.ukmId,
            kategori: params.kategori,
            subKategori: params.subKategori,
        },
    });
    const { data } = await axios.get<GetAssetRevenueResponse>(apiGetItem);
    return data.data;
};

export default function useAssetRevenue(params: ParamsGetAssetRevenue) {
    return useQuery<GetAssetRevenueResponse["data"] | null>(
        ["asset-revenue", params],
        () => handleRequest(params),
        {
            enabled: !!params?.ukmId,
        },
    );
}
